export default "__VITE_ASSET__BSyMYncG__"